module.exports = "../../../../platform/assets/pageMainIcon/yewushezhilei2.svg";